import React, { Component } from "react";
import {
  Router,
  RouterProps,
  Styled
} from "../../../toolkit/decorators/Artifact";
import { Nav, NavItem, NavLink, TabContent } from "reactstrap";
import TabMovimientos from "./tabs/tabMovimientos";
import TabBitacora from "./tabs/tabBitacora";
import ExternoDetalle from "../../../types/ExternoDetalle";
import s from "./styles.scss";
import permissionCodes from "../../../utils/permissionCodes";
import { userHasPermission } from "../../../utils/accessTree";

const {
  PERSONA_EXTERNA_TAB_BITACORA: TAB_BITACORA,
  PERSONA_EXTERNA_TAB_MOVIMIENTOS: TAB_MOVIMIENTOS
} = permissionCodes;

interface Props extends RouterProps<any> {
  detalle: ExternoDetalle;
}

interface State {
  activeTab: string;
}

@Router()
@Styled(s)
export default class ExternoDetalleTabs extends Component<Props, State> {
  state: Readonly<State> = {
    activeTab: "mov"
  };

  toggleTab = (tab: string) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  tabStyle = (tab: string) =>
    `${this.state.activeTab === tab ? "active" : ""} ${s.tab}`;

  render() {
    const { detalle } = this.props;

    return (
      <>
        <Nav className={s.tabs} tabs>
          {userHasPermission(TAB_MOVIMIENTOS) && (
            <NavItem>
              <NavLink
                className={this.tabStyle("mov")}
                onClick={() => this.toggleTab("mov")}
              >
                Movimientos
              </NavLink>
            </NavItem>
          )}
          {userHasPermission(TAB_BITACORA) && (
            <NavItem>
              <NavLink
                className={this.tabStyle("bit")}
                onClick={() => this.toggleTab("bit")}
              >
                Bitácora
              </NavLink>
            </NavItem>
          )}
        </Nav>

        <TabContent className="h-100" activeTab={this.state.activeTab}>
          {this.state.activeTab === "mov" && (
            <TabMovimientos detalle={detalle as any} {...({} as any)} />
          )}

          {this.state.activeTab === "bit" && (
            <TabBitacora detalle={detalle as any} {...({} as any)} />
          )}
        </TabContent>
      </>
    );
  }
}
